import _ from 'lodash'
import Table from './Table'
import Toolbar from './Toolbar'
import { useEffectOnce } from 'react-use'
import { useLocation } from 'react-router-dom'
import { getSkuFeatureRelationList } from 'api/Product'
import React, { useState, useEffect, useCallback, useRef } from 'react'

const FilterList = props => {
  const ref = useRef()
  const location = useLocation()
  const [data, setData] = useState([])
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    getSkuFeatureRelationList(too).then(setData)
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  // function handleSearchChange (payload, delay) {
  //   handleParamsChange(payload, delay)
  // }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar {...props} />
        <br />
        <Table data={data} page={params.page} onPageChange={handlePageChange} {...props} />
      </div>
    </div>
  )
}

export default FilterList
